'use client';

import { useState } from 'react';
import { clsx } from '@libs/common-next';
import { TextLink } from '@petsmart-ui/sparky';
import LinkBlock from './LinkBlock';

import type { LinkTilesProps } from '../types';
import './Tile4Links.scss';

export default function Tile4LinksMobile({ tiles }: Pick<LinkTilesProps, 'tiles'>) {
    const [isMoreClicked, setIsMoreClicked] = useState(false);

    return (
        <div className={clsx('tile4-links--mobile', isMoreClicked && 'tile4-links--mobile--spread')}>
            {tiles.map((linkBlock, index) => (
                <LinkBlock
                    key={linkBlock.sysId}
                    {...linkBlock}
                    {...([2, 3].includes(index) && !isMoreClicked && { style: { display: 'none' } })}
                />
            ))}
            <TextLink className="tile4-links--mobile__link" onClick={() => setIsMoreClicked(!isMoreClicked)}>
                {isMoreClicked ? 'Show Less' : 'Show More'}
            </TextLink>
        </div>
    );
}
